import { Grid, Stack, Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import {
  CardOptionTypography,
  CardOptionHintTypography,
} from 'components/styles_components/typography';
import { GrayCard } from 'components/styles_components/card';
import Ratio from 'components/compliance_stats/ratio';

const clickableClass = (handler) => (handler ? 'button' : undefined);

const Container = ({
  complianceRatio,
  overdueInspectionsTotal,
  incomingInspectionsTotal,
  pendingInspectionsTotal,
  onOverdueClick,
  onIncomingClick,
  onPendingClick,
}) => (
  <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
    <Grid size={{ xs: 6, lg: 3 }}>
      <GrayCard>
        <Stack>
          <CardOptionTypography>
            <FormattedMessage id="place.complianceRatio" />
          </CardOptionTypography>
          <Ratio complianceRatio={complianceRatio} />
          <CardOptionHintTypography>
            <FormattedMessage id="inspections.compliance_ratio.description" />
          </CardOptionHintTypography>
        </Stack>
      </GrayCard>
    </Grid>
    <Grid size={{ xs: 6, lg: 3 }}>
      <GrayCard onClick={onOverdueClick} className={clickableClass(onOverdueClick)}>
        <Stack>
          <CardOptionTypography>
            <FormattedMessage id="inspection.overdue.count" />
          </CardOptionTypography>
          <Typography
            component="span"
            color={overdueInspectionsTotal > 0 ? 'error' : 'secondary'}
          >
            {overdueInspectionsTotal}
          </Typography>
          <CardOptionHintTypography>
            <FormattedMessage id="inspection.overdue.count.description" />
          </CardOptionHintTypography>
        </Stack>
      </GrayCard>
    </Grid>
    <Grid size={{ xs: 6, lg: 3 }}>
      <GrayCard onClick={onIncomingClick} className={clickableClass(onIncomingClick)}>
        <Stack>
          <CardOptionTypography>
            <FormattedMessage id="inspection.incoming.count" />
          </CardOptionTypography>
          <Typography
            component="span"
            color={incomingInspectionsTotal > 0 ? 'warning' : 'secondary'}
          >
            {incomingInspectionsTotal}
          </Typography>
          <CardOptionHintTypography>
            <FormattedMessage id="inspection.incoming.count.description" />
          </CardOptionHintTypography>
        </Stack>
      </GrayCard>
    </Grid>
    <Grid size={{ xs: 6, lg: 3 }}>
      <GrayCard onClick={onPendingClick} className={clickableClass(onPendingClick)}>
        <Stack>
          <CardOptionTypography>
            <FormattedMessage id="inspection.pending.count" />
          </CardOptionTypography>
          <Typography component="span">{pendingInspectionsTotal}</Typography>
          <CardOptionHintTypography>
            <FormattedMessage id="inspection.count.description" />
          </CardOptionHintTypography>
        </Stack>
      </GrayCard>
    </Grid>
  </Grid>
);

export default Container;
